import * as yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(yup);

export const SignUpSchema = yup.object().shape({
  username: yup
    .string()
    .min(3)
    .max(30, 'Username to long')
    .matches(
      /^[a-zA-Z0-9_-]*$/,
      'Only letters, numbers, dashes and underscores are supported.'
    )
    .test('noSpaces', 'Username cannot contain spaces', (value) => {
      return /^\S*$/.test(value);
    })
    .required(),
  email: yup.string().email().required(),
  password: yup
    .string()
    .required('The password field is required')
    .min(8, 'The password must contain 8 or more characters')
    .minLowercase(1, 'The password must contain 1 lowercase letter')
    .minUppercase(1, 'The password must contain 1 uppercase letter')
    .minNumbers(1, 'The password must contain 1 number')
    .minSymbols(1, 'The password must contain 1 special character'),
  confirmpassword: yup
    .string()
    .oneOf(
      [yup.ref('password'), null],
      'Password should be match with confirm password'
    )
    .required('The confirm password field is required'),
  country: yup.string().required('The country field is required'),
  month: yup.array().min(1, 'Month required.'),
  day: yup.array().min(1, 'Day required.'),
  year: yup.array().min(1, 'Year required.'),
  termsOfUse: yup.boolean().required(),
});
